import _, { findIndex } from 'lodash'
import { swap, moveInArray } from '../../lib/Tools'

const s = JSON.stringify

/**
 * reviews and fixes issues in the list's ordering
 */
export default function fixOrder(list) {
  const length = list.length
  let newList = [...list]

  // we collect all expenses with the item key, for references
  const expenses = {}
  list.forEach(item => {
    if (item.expense) expenses[item.key] = item.expense
  })

  const isHotel = item => (
    item.type == "expense" && (item.expense || expenses[item.ref]).type == "hotel"
  )

  // make sure the first item is the first day!
  if (newList[0].type != "day") {
    const firstDayIdx = findIndex(newList, x => x.type == "day")
    newList = moveInArray(newList, firstDayIdx, 0)
  }

  // guard against infinite loop for debugging
  // i leave it in just in case, with a warning
  let laps = 0
  const tooFuckingMuch = () => { 
    if (++laps >= 50) {
      alert("fixOrder.js:fixOrder, posible bucle infinito")
      return true
    }
    else {
      return false
    }
  }

  let aok = true

  do {
    aok = true 
    // we skip the first and the last, they're fine
    for (let i = 1; i < length - 1; i++) {
      const currentItem = newList[i]
      const nextItem = newList[i + 1]

      // hotels must be the last in the day: that is, the next thing must be another hotel, or the next day
      if (isHotel(currentItem) && nextItem.type != "day" && !isHotel(nextItem)) {
        aok = false
        newList = swap(newList, i, i + 1)
      }
    }
  } while (!aok && !tooFuckingMuch())

  return newList
}
